import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { spaceConfigEdit } from "../../api/space/spaceConfigEdit"
import { STORAGE_KEYS } from "../../lib/constants"
import { queries } from "../../queries"
import { useUserPermissions } from "../useUserPermissions"
import { usePrimaryColor } from "./usePrimaryColor"

type MantineEvent = Event & {
  detail: {
    key: string
    value: string
  }
}

export const useDatabasePrimaryColor = () => {
  const [primaryColor, setPrimaryColor] = usePrimaryColor()
  const { CAN_EDIT_PRIMARY_COLOR } = useUserPermissions()

  const { data } = useQuery({
    ...queries.space.config(),
    staleTime: 0,
    refetchOnWindowFocus: false
  })

  useEffect(() => {
    if (data && primaryColor !== data.data.theme.colors.primary) {
      setPrimaryColor(data.data.theme.colors.primary)
    }
  }, [data])

  useEffect(() => {
    const handleUpdateColor = async (event: Event) => {
      const { detail } = event as MantineEvent

      if (detail.key === STORAGE_KEYS.PRIMARY_COLOR) {
        if (CAN_EDIT_PRIMARY_COLOR) {
          await spaceConfigEdit({ primaryColor: detail.value })
        }
      }
    }
    window.addEventListener("mantine-local-storage", handleUpdateColor)

    return () => {
      window.removeEventListener("mantine-local-storage", handleUpdateColor)
    }
  }, [CAN_EDIT_PRIMARY_COLOR])
}
